import React, { FC, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { PaddedPaper } from 'components';
import { ClientDepartmentFragment, ClientLocationFragment, UserStatus } from 'api';

import { ClearFiltersButton } from '../shared';
import { UserSearchesV2Filter } from './type';
import { Chips, Filters } from './index';

interface Props {
  filter: UserSearchesV2Filter;
  setFilter: (filter: UserSearchesV2Filter) => void;
  clearFilter: () => void;
  hasFilters: boolean;
}

const FilterBar: FC<Props> = ({ filter, setFilter, clearFilter, hasFilters }) => {
  const { t } = useTranslation();

  const [selectedDepartments, setSelectedDepartments] = useState<Array<ClientDepartmentFragment>>(
    []
  );
  const [selectedLocations, setSelectedLocations] = useState<Array<ClientLocationFragment>>([]);

  return (
    <PaddedPaper>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Filters
                filter={filter}
                setFilter={setFilter}
                clearFilter={clearFilter}
                setSelectedDepartments={setSelectedDepartments}
                setSelectedLocations={setSelectedLocations}
              />
            </Grid>

            {filter.user_status === UserStatus.Active && (
              <Grid item>
                <Typography color="textSecondary">
                  {t('admin:userManagementFilterDescription')}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        {hasFilters && (
          <Grid item>
            <ClearFiltersButton onClick={clearFilter} />
          </Grid>
        )}
      </Grid>
      <Chips
        filter={filter}
        setFilter={setFilter}
        isEmpty={!hasFilters}
        selectedDepartments={selectedDepartments}
        selectedLocations={selectedLocations}
      />
    </PaddedPaper>
  );
};

export default FilterBar;
